/*
 * Common Messages
 *
 * This contains all the text for the Common text used cross the application.
 */
import { defineMessages } from "@formatjs/intl";
export default defineMessages({
  at: {
    id: "common.at",
    defaultMessage: "at"
  },
  body: {
    id: "common.body",
    defaultMessage: "Body"
  },
  publishDate: {
    id: "common.publishDate",
    defaultMessage: "Publish Date"
  },
  emptyState: {
    id: "common.emptyState",
    defaultMessage: "No Data To Display"
  },
  items: {
    id: "items",
    defaultMessage: "items"
  },
  create: {
    id: "create",
    defaultMessage: "Create"
  },
  markAll: {
    id: "markAll",
    defaultMessage: "Mark all"
  },
  today: {
    id: "today",
    defaultMessage: "Today"
  },
  saturday: {
    id: "saturday",
    defaultMessage: "Saturday"
  },
  sunday: {
    id: "sunday",
    defaultMessage: "Sunday"
  },
  monday: {
    id: "monday",
    defaultMessage: "Monday"
  },
  tuesday: {
    id: "tuesday",
    defaultMessage: "Tuesday"
  },
  wednesday: {
    id: "wednesday",
    defaultMessage: "Wednesday"
  },
  thursday: {
    id: "thursday",
    defaultMessage: "Thursday"
  },
  friday: {
    id: "friday",
    defaultMessage: "Friday"
  },
  defaultView: {
    id: "defaultView",
    defaultMessage: "Default view"
  },
  localImageError: {
    id: "localImageError",
    defaultMessage: "This is a local image please use image uploader"
  },
  hi: {
    id: "hi",
    defaultMessage: "Hi"
  },
  "in": {
    id: "in",
    defaultMessage: "in"
  },
  resend: {
    id: "resend",
    defaultMessage: "resend"
  },
  verified: {
    id: "verified",
    defaultMessage: "Verified"
  },
  proceed: {
    id: "proceed",
    defaultMessage: "Proceed"
  },
  ok: {
    id: "ok",
    defaultMessage: "OK"
  },
  cancel: {
    id: "cancel",
    defaultMessage: "Cancel"
  },
  am: {
    id: "am",
    defaultMessage: "AM"
  },
  pm: {
    id: "pm",
    defaultMessage: "PM"
  },
  updateDate: {
    id: "common.updateDate",
    defaultMessage: "Update Date"
  },
  actions: {
    id: "common.actions",
    defaultMessage: "Actions"
  },
  sort: {
    id: "common.sort",
    defaultMessage: "Sort"
  },
  preview: {
    id: "common.preview",
    defaultMessage: "Preview"
  },
  replace: {
    id: "common.replace",
    defaultMessage: "Replace"
  },
  "delete": {
    id: "common.delete",
    defaultMessage: "Delete"
  },
  upload: {
    id: "common.upload",
    defaultMessage: "Upload"
  },
  download: {
    id: "common.download",
    defaultMessage: "download"
  },
  "for": {
    id: "common.for",
    defaultMessage: "for"
  },
  error: {
    id: "common.error",
    defaultMessage: "Error"
  },
  updated: {
    id: "common.updated",
    defaultMessage: "Updated"
  },
  weekly: {
    id: "common.weekly",
    defaultMessage: "Weekly"
  },
  exams: {
    id: "common.exams",
    defaultMessage: "Exams"
  },
  className: {
    id: "common.className",
    defaultMessage: "Class Name"
  },
  uploadSelectedLabel: {
    id: "common.uploadSelectedLabel",
    defaultMessage: "Upload Selected"
  },
  downloadSelectedLabel: {
    id: "common.downloadSelectedLabel",
    defaultMessage: "Download Selected"
  },
  linkNotify: {
    id: "common.linkNotify",
    defaultMessage: "Please select text to create a link."
  },
  somethingWentWrong: {
    id: "common.somethingWentWrong",
    defaultMessage: "Something went wrong"
  },
  comingSoon: {
    id: "common.comingSoon",
    defaultMessage: "Coming Soon"
  },
  confirmUnderstanding: {
    id: "common.confirmUnderstanding",
    defaultMessage: "I understand"
  },
  gradableItems: {
    id: "common.gradableItems",
    defaultMessage: "Gradable Items"
  },
  original: {
    id: "common.original",
    defaultMessage: "Original"
  },
  material: {
    id: "common.material",
    defaultMessage: "Material"
  },
  goTo: {
    id: "common.goTo",
    defaultMessage: "Go to"
  },
  stretchTypography: {
    id: "common.stretchTypography",
    defaultMessage: "Stretch"
  },
  resetWidth: {
    id: "common.resetWidth",
    defaultMessage: "Reset Width"
  },
  noOptionsTypography: {
    id: "common.noOptionsTypography",
    defaultMessage: "No options"
  },
  saveEditsTypography: {
    id: "common.saveEditsTypography",
    defaultMessage: "Save Edits"
  },
  importTypography: {
    id: "common.importTypography",
    defaultMessage: "Import"
  },
  compact: {
    id: "common.compact",
    defaultMessage: "Compact"
  },
  standard: {
    id: "common.standard",
    defaultMessage: "Standard"
  },
  comfortable: {
    id: "common.comfortable",
    defaultMessage: "Comfortable"
  },
  confirm: {
    id: "common.confirm",
    defaultMessage: "Confirm"
  },
  declineAll: {
    id: "common.declineAll",
    defaultMessage: "Decline All"
  },
  approveAll: {
    id: "common.approveAll",
    defaultMessage: "Approve All"
  },
  endDate: {
    id: "common.endDate",
    defaultMessage: "End Date"
  },
  cantDownloadTypography: {
    id: "common.cantDownloadTypography",
    defaultMessage: "Can't Download"
  },
  emptyDataTypography: {
    id: "common.emptyDataTypography",
    defaultMessage: "'s Empty Data"
  },
  seenByTypography: {
    id: "common.seenByTypography",
    defaultMessage: "Seen by"
  },
  userTypography: {
    id: "common.userTypography",
    defaultMessage: "user"
  },
  usersTypography: {
    id: "common.usersTypography",
    defaultMessage: "users"
  },
  notSeenYetTypography: {
    id: "common.notSeenYetTypography",
    defaultMessage: "Not seen yet"
  },
  clearTypography: {
    id: "common.clearTypography",
    defaultMessage: "Clear"
  },
  dayDate: {
    id: "common.dayDate",
    defaultMessage: "Day Date"
  },
  noDataTypography: {
    id: "common.noDataTypography",
    defaultMessage: "No Data"
  },
  headOfDepartmentTypography: {
    id: "common.headOfDepartmentTypography",
    defaultMessage: "Head of Department"
  },
  days: {
    id: "common.days",
    defaultMessage: "Days"
  },
  currency: {
    id: "common.currency",
    defaultMessage: "EGP"
  },
  dateAndTime: {
    id: "common.dateAndTime",
    defaultMessage: "Date & Time"
  },
  tryAgain: {
    id: "common.tryAgain",
    defaultMessage: "Try Again"
  },
  expireDate: {
    id: "common.expireDate",
    defaultMessage: "Expire Date"
  },
  applyFilter: {
    id: "common.applyFilter",
    defaultMessage: "Apply Filter"
  },
  selectChild: {
    id: "common.selectChild",
    defaultMessage: "Select Child"
  },
  allChildren: {
    id: "common.allChildren",
    defaultMessage: "All Children"
  },
  apply: {
    id: "common.apply",
    defaultMessage: "Apply"
  },
  errorMessage: {
    id: "common.errorMessage",
    defaultMessage: "There is an error, please try again."
  },
  childrenTypography: {
    id: "common.childrenTypography",
    defaultMessage: "Children"
  },
  searchForUsers: {
    id: "common.searchForUsers",
    defaultMessage: "Search For Users"
  },
  selectUsers: {
    id: "common.selectUsers",
    defaultMessage: "Select Users"
  },
  newestToOldestTypography: {
    id: "common.newestToOldestTypography",
    defaultMessage: "Newest To Oldest"
  },
  oldestToNewestTypography: {
    id: "common.oldestToNewestTypography",
    defaultMessage: "Oldest To Newest"
  },
  descriptionIsRequired: {
    id: "common.descriptionIsRequired",
    defaultMessage: "Description is required"
  },
  descriptionCharactersValidation: {
    id: "common.descriptionCharactersValidation",
    defaultMessage: "Description must be at least 3 characters"
  },
  courseSelectValidation: {
    id: "common.courseSelectValidation",
    defaultMessage: "Please select a course"
  },
  userSelectValidation: {
    id: "common.userSelectValidation",
    defaultMessage: "Please select at least one user"
  },
  descriptionPlaceHolder: {
    id: "common.descriptionPlaceHolder",
    defaultMessage: "Describe your problem"
  },
  optionalTypography: {
    id: "common.optionalTypography",
    defaultMessage: "Optional"
  },
  uploadFileTypography: {
    id: "common.uploadFileTypography",
    defaultMessage: "Upload File"
  },
  tagsTypography: {
    id: "common.tagsTypography",
    defaultMessage: "Tags"
  },
  searchForTags: {
    id: "common.searchForTags",
    defaultMessage: "Search for tags"
  },
  tagsPlaceHolder: {
    id: "common.tagsPlaceHolder",
    defaultMessage: "Select tags"
  },
  contactInformationTypography: {
    id: "common.contactInformationTypography",
    defaultMessage: "Contact information"
  },
  searchUsersTypography: {
    id: "common.searchUsersTypography",
    defaultMessage: "Search Users"
  },
  idTypography: {
    id: "common.idTypography",
    defaultMessage: "ID"
  },
  writeMessagePlaceHolder: {
    id: "common.writeMessagePlaceHolder",
    defaultMessage: "Write Message"
  },
  openTypography: {
    id: "common.openTypography",
    defaultMessage: "Open"
  },
  closedTypography: {
    id: "common.closedTypography",
    defaultMessage: "Closed"
  },
  inProgressTypography: {
    id: "common.inProgressTypography",
    defaultMessage: "In Progress"
  },
  resolvedTypography: {
    id: "common.resolvedTypography",
    defaultMessage: "Resolved"
  },
  creationDate: {
    id: "common.creationDate",
    defaultMessage: "Creation Date"
  },
  stages: {
    id: "common.stages",
    defaultMessage: "Stage(s)"
  },
  enterName: {
    id: "common.enterName",
    defaultMessage: "Enter Name"
  },
  enterTag: {
    id: "common.enterTag",
    defaultMessage: "Enter Tag"
  },
  requiredName: {
    id: "common.requiredName",
    defaultMessage: "Name is required"
  },
  validName: {
    id: "common.validName",
    defaultMessage: "Please enter a valid name"
  },
  requiredTags: {
    id: "common.requiredTags",
    defaultMessage: "Tags are required"
  },
  networkErrorTypography: {
    id: "common.networkErrorTypography",
    defaultMessage: "Network Error"
  },
  previewErrorTypography: {
    id: "common.previewErrorTypography",
    defaultMessage: "Preview Error"
  },
  selectStageTypography: {
    id: "common.selectStageTypography",
    defaultMessage: "Select Stage"
  },
  selectClassTypography: {
    id: "common.selectClassTypography",
    defaultMessage: "Select Class"
  },
  selectStudentTypography: {
    id: "common.selectStudentTypography",
    defaultMessage: "Select Student"
  },
  selectStudentsTypography: {
    id: "common.selectStudentsTypography",
    defaultMessage: "Select Students"
  },
  searchStudentsTypography: {
    id: "common.searchStudentsTypography",
    defaultMessage: "Search Students"
  },
  searchStagesTypography: {
    id: "common.searchStagesTypography",
    defaultMessage: "Search Stages"
  },
  searchClassesTypography: {
    id: "common.searchClassesTypography",
    defaultMessage: "Search Classes"
  }
});